/** Минимальная высота блока дней и слотов до прихода данных — снижает CLS. */
export const SCHEDULE_CALENDAR_MIN_HEIGHT_PX = 162
